export default __webpack_public_path__ + "static/media/heart_purple.bde249e1.svg";